import React, { useEffect, useMemo } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models, service } from "powerbi-client";
import { connect, ConnectedProps } from "react-redux";

import * as Actions from "us.collection.admin/actions";
import "./ReportViewer.scss";
import { RootState } from "us.helper/types";
import { $Empty, $Skeleton, $Tabs } from "us.common/components";
import { PowerBIReport } from "us.collection.admin/reducers/PowerBIDashboard/PowerBIDashboard";
import { isEmptyArray } from "formik";
import { useTranslation } from "react-i18next";

const ReportViewer: React.FC<PropsFromRedux> = (props) => {
  const { reports, getPowerBIReports } = props;
  const { t } = useTranslation();

  /**
   * Default configurations for Power BI reports
   */
  const defaultConfig = {
    tokenType: models.TokenType.Aad,
    permissions: models.Permissions.Read,
    type: "report", // Supported types: report, dashboard, tile, visual and qna
    settings: {
      panes: { filters: { visible: true }, pageNavigation: { visible: true } },
      navContentPaneEnabled: true,
      filterPaneEnabled: true,
      layoutType: models.LayoutType.Master,
    },
  };

  useEffect(() => {
    getPowerBIReports && getPowerBIReports({});
  }, []);

  const tabItems = useMemo(() => {
    try {
      if (reports.data && reports.data.reports.length > 0) {
        return reports.data.reports.map((report: PowerBIReport) => ({
          key: report.id,
          label: report.name,
          children: (
            <PowerBIEmbed
              embedConfig={{
                ...defaultConfig,
                accessToken: reports.data ? reports.data.token : "",
                id: report.id,
                embedUrl: report.embedUrl,
              }}
              eventHandlers={
                new Map([
                  ["loaded", () => console.log("Report has loaded")],
                  ["rendered", () => console.log("Report has rendered")],
                  [
                    "error",
                    (event?: service.ICustomEvent<any>) => {
                      if (event) {
                        console.error(event.detail);
                      }
                    },
                  ],
                  ["visualClicked", () => console.log("visual clicked")],
                  ["pageChanged", (event) => console.log(event)],
                ])
              }
              cssClassName="power-bi-report"
            />
          ),
        }));
      }
    } catch (error) {
      return [];
    }
  }, [reports.data]);

  return (
    <div className="powerbi-container">
      <$Skeleton loading={reports.isLoading} active paragraph={{ rows: 3 }}>
        {tabItems && !isEmptyArray(tabItems) ? (
          <$Tabs
            className="bui-tabs"
            defaultActiveKey={"COLLECTION_FEE_BASIS"}
            onTabClick={(key: any) => {
              console.log("Tab clicked: ", key);
            }}
            items={tabItems}
          />
        ) : (
          <$Empty
            image={$Empty.PRESENTED_IMAGE_SIMPLE}
            description={t("COMMON.NO_DATA")}
            className="m-4"
          />
        )}
      </$Skeleton>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const { reports } = state.powerBIDashboard;
  return { reports };
};

const { reports } = Actions.powerBIDashboard;

const mapDispatchToProps = {
  getPowerBIReports: reports.get,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ReportViewer);
